export const cacheKeys = {
  getBroadcasts: (params) =>
    params ? ['getBroadcasts', params] : ['getBroadcasts'],
};
